






















































































































/** @format */
import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import { getParkServiceDetailAPI, editParkServiceAPI } from '@/api/setting-management';
import ServiceSetting from '../self-service-setting/index.vue';
import { isShiDaill } from '@/utils/env';

@Component({
  name: 'CRule',
  components: {
    BdSwitch: () => import('@/components/bd-switch'),
    ServiceSetting
  }
})
export default class CRule extends Vue {
  isShiDaill: boolean = isShiDaill;
  private title: string = '线上业务设置';
  form: any = null;
  c_rule_visible: boolean = false;
  // form布局
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  };

  // 表单需要的参数
  private formParams: any = {
    pkServiceId: '',
    carChange: '01', // 车辆变更
    payPal: '01', // 电子支付
    monthRenew: '00', // 长租在线续约
    carSubscribe: '00', // 来访车辆预约
    carLock: '00', // 锁车解锁
    invoice: '00', // 电子发票
    couponGrantMax: '' //领取上限
  };

  // 编辑表单
  private editInfo: any = {
    ...this.formParams
  };

  // 编辑详情数据
  private detailData: any = null;

  private isDisabled: boolean = true;
  spining: boolean = false;

  isLimit: string = '00';
  reviewMaxTime = 24;
  payMaxTime = 24;
  // 机构ID
  @Prop({ type: String, default: '' })
  organizationId!: string;

  // 车场ID
  @Prop({ type: String, default: '' })
  parkId!: string;

  // 监听visible
  @Watch('parkId', { immediate: true })
  onChangeParkId(newVal: boolean, oldVal: boolean) {
    this.initData();
  }

  // 编辑，提交，表单验证
  handleEditSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: any) => {
      if (!err) {
        this.editData();
      }
    });
  }

  // 重置数据
  async handleResetData() {
    /* let { detailData } = this
      if (detailData) {
        this.isDisabled = true
        await this.resetEditData(detailData)
      } else {
        await this.initData()
      } */
    await this.initData();
  }

  // 编辑－请求数据
  async editData() {
    if (this.spining) return;
    this.spining = true;
    try {
      const { parkId, editInfo } = this;
      const params: any = {};
      Object.keys(editInfo).forEach(item => {
        if (item !== 'pkServiceId') {
          params[item] = +editInfo[item] === 1 ? '01' : '00';
        } else {
          params[item] = editInfo[item];
        }
      });
      const { couponGrantMax } = editInfo;
      if (this.isLimit == '00') {
        params.couponGrantMax = 0;
      } else {
        if (String(couponGrantMax) == '') {
          return this.$message.warning('张数不可为空');
        }
        if (!/^[1-9]\d*$/.test(couponGrantMax)) {
          return this.$message.warning('张数只能为正整数');
        }
        if (Number(couponGrantMax) > 99999) {
          return this.$message.warning('张数最大为99999');
        }
        params.couponGrantMax = Number(couponGrantMax);
      }
      let { status, code, msg, data } = await editParkServiceAPI({
        ...params,
        reviewMaxTime: this.reviewMaxTime || '24',
        payMaxTime: this.payMaxTime || '24',
        ...{
          parkId
        }
      });
      if (status === '9999') {
        this.$message.success('保存成功');
        this.isDisabled = true;
        this.editInfo.pkServiceId = data; // 更新一下ID
        // this.$emit('create', { ...values, invoiceId: data.invoiceId })
        // this.form.resetFields()
      } else {
        this.$message.error(msg || '保存失败！');
      }
    } catch (error) {
      // console.log(error)
      this.$message.error((error && error.msg) || '保存失败！');
    } finally {
      this.spining = false;
    }
  }

  // 详情
  async getEditDetailData() {
    try {
      const { parkId } = this;
      const { status, code, msg, data } = await getParkServiceDetailAPI({
        parkId
      });
      if (status === '9999') {
        this.detailData = data || null;
        this.payMaxTime = data.payMaxTime || '24';
        this.reviewMaxTime = data.reviewMaxTime || '24';
      } else {
        this.$message.error(msg || '获取详情失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '获取详情失败！');
    }
  }

  // 重置编辑表单
  async resetEditData(detailData: any) {
    const { formParams } = this;
    this.form = this.$form.createForm(this, {});
    this.editInfo = {
      ...formParams
    };
    if (detailData) {
      // 修改
      Object.keys(formParams).forEach(item => {
        if (item !== 'pkServiceId') {
          if (item === 'carChange' || item === 'payPal') {
            this.editInfo[item] = detailData[item] !== null && detailData[item] !== undefined ? detailData[item] : '01';
          } else if (item == 'couponGrantMax') {
            this.editInfo[item] = detailData[item] == 0 ? '' : detailData[item];
            this.isLimit = detailData[item] > 0 ? '01' : '00';
          } else {
            this.editInfo[item] = detailData[item] || '00';
          }
        } else {
          this.editInfo[item] = detailData[item];
        }
      });
    }
  }

  // c端配置 开始
  isCDisabled = false;

  // c端配置 结束

  // 初始化数据
  async initData() {
    const { parkId } = this;
    this.isDisabled = true;
    if (parkId) {
      // 根据ID-判断是否编辑
      await this.getEditDetailData();
    }
    await this.resetEditData(this.detailData);
  }

  // 生命周期初始化
  async created() {
    // await this.initData()
  }

  async activated() {
    this.initData();
  }
}
